/* eslint-disable react/jsx-props-no-spreading */
import { PopperProps, SxProps, Theme } from '@mui/material';
import React, { ReactEventHandler } from 'react';
import {
  CustomConfirmDialogProps,
  OkCancelConfirmDialogProps,
  YesNoConfirmDialogProps,
} from '../../Button/ETOButtonCommonProps';
import ModalNavbarSubItem from './ModalNavbarSubItem';
import NavButton from './NavButton';
import NavModal from './NavModal';

export interface ButtonModalMenuItem {
  componentName?: string;
  icon?: React.ReactNode;
  handleClick?: ReactEventHandler | any;
  handleClose?: ReactEventHandler;
  customComponent?: React.ReactElement;
  onlyCustomComponent?: boolean;
  confirm?:
    | CustomConfirmDialogProps
    | YesNoConfirmDialogProps
    | OkCancelConfirmDialogProps;
}

interface ModalNavBarItemProps {
  buttonStyle?: SxProps<Theme>;
  componentName?: string;
  icon: React.ReactNode;
  modalMenuItems?: (ButtonModalMenuItem | false)[];
  modalProps?: Omit<PopperProps, 'children' | 'open'>;
  disabled?: boolean;
  customNavModalSx?: SxProps<Theme>;
}

const ModalNavBarItem = (props: ModalNavBarItemProps) => {
  const {
    modalMenuItems,
    buttonStyle,
    componentName,
    icon,
    modalProps,
    disabled,
    customNavModalSx,
  } = props;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  return (
    <>
      <NavButton
        anchorRef={anchorRef}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        buttonStyle={buttonStyle}
        componentName={componentName}
        icon={icon}
        disabled={disabled}
      />
      <NavModal
        anchorRef={anchorRef}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        modalProps={modalProps}
        customNavModalSx={customNavModalSx}
      >
        {modalMenuItems
          && modalMenuItems.map((menuItem, index) => (menuItem ? (
            <ModalNavbarSubItem
              onlyCustomComponent={menuItem.onlyCustomComponent}
              customComponent={menuItem.customComponent}
              key={
                  menuItem.componentName
                    ? menuItem.componentName
                    : `subItem--${index}`
                }
              componentName={
                  menuItem.componentName
                    ? menuItem.componentName
                    : `componentItem--${index}`
                }
              icon={menuItem.icon}
              handleClick={(
                e: React.MouseEvent<HTMLLIElement, MouseEvent>,
              ) => {
                menuItem.handleClick();
                // eslint-disable-next-line no-unused-expressions
                !menuItem.handleClose && setIsModalOpen(false);
                menuItem?.handleClose?.(e);
                setIsModalOpen(false);
              }}
              confirm={menuItem.confirm}
              setIsModalOpen={setIsModalOpen}
            />
          ) : null),)}
      </NavModal>
    </>
  );
};
export default ModalNavBarItem;
